import { render, staticRenderFns } from "./container_purchase.vue?vue&type=template&id=d0deb2a4&scoped=true&"
import script from "./container_purchase.vue?vue&type=script&lang=js&"
export * from "./container_purchase.vue?vue&type=script&lang=js&"
import style0 from "./container_purchase.vue?vue&type=style&index=0&id=d0deb2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0deb2a4",
  null
  
)

export default component.exports